import { PaintedScene } from '../PaintedScene';

export const KITE_HILL_SHRINE_PHASER_KEY = 'KiteHillShrineScene' as const;
export const KITE_HILL_SHRINE_MANIFEST_KEY = 's-204-kite-hill-shrine' as const;

export class KiteHillShrineScene extends PaintedScene {
  constructor() {
    super(KITE_HILL_SHRINE_PHASER_KEY, KITE_HILL_SHRINE_MANIFEST_KEY);
  }
}
